import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

const Popup = ({ onClose, onConfirm }) => {
  const { t } = useTranslation()

  const { text_primary_color, url_log_out } = useAppSelector(selectBranding)

  const router = useRouter()
  const redirect = () => {
    router.push(url_log_out || 'https://proofix.ru')
  }

  return (
    <div className="lk-toast-connection-state lk-toast lk-popup-content">
      <p style={{ color: `${text_primary_color}` }}>{t('exitQuestion')}</p>

      <div className="lk-popup-buttons">
        <button
          className="lk-disconnect-button"
          style={{ marginRight: '10px' }}
          onClick={() => redirect()}
        >
          {t('leave')}
        </button>

        <button className="lk-button" onClick={onClose}>
          {t('cancel')}
        </button>
      </div>
    </div>
  )
}

export default Popup
